var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssigneePlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V54C64 59.5228 59.5228 64 54 64H10C4.47715 64 0 59.5228 0 54V10Z",
    fill: "#DDDDDD"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V54C64 59.5228 59.5228 64 54 64H10C4.47715 64 0 59.5228 0 54V10Z",
    fill: "#DDDDDD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 61.3346C59 61.3346 59 51.6377 52.1377 48.1092C47.7969 45.8754 49.4638 47.5846 44.1331 45.3C38.8023 43.0238 37.5415 42.2792 37.5415 42.2792L37.4908 37.05C37.4908 37.05 39.4877 35.4846 40.1138 30.5431C41.3577 30.9154 41.7808 29.0369 41.8485 27.8354C41.9246 26.6762 42.5846 23.0546 41.0615 23.3762C41.3746 20.9562 41.62 18.7731 41.51 17.6138C41.1208 13.5523 38.4046 9.31308 31.5423 9C25.7038 9.31308 21.9215 13.5523 21.5408 17.6138C21.4308 18.7731 21.6592 20.9562 21.9638 23.3762C20.4408 23.0462 21.0923 26.6762 21.16 27.8354C21.2362 29.0369 21.6423 30.9238 22.8946 30.5515C23.5123 35.4931 25.5092 37.0754 25.5092 37.0754L25.4585 42.33C25.4585 42.33 24.1977 43.1254 18.8669 45.4015C13.5362 47.6862 15.2031 45.8754 10.8623 48.1008C4 51.6377 4 61.3346 4 61.3346V61.3431C4 62.8069 5.15077 64 6.58077 64H56.4277C57.8492 64 59 62.8069 59 61.3346Z",
    fill: "#BBBBBB"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigneePlaceholder);
export default __webpack_public_path__ + "static/media/assignee-placeholder.7b213127d3650caa6e39fc9b46d5bbf9.svg";
export { ForwardRef as ReactComponent };